import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { LazyLoadEvent, MenuItem } from 'primeng/api';

import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MenuModule } from 'primeng/menu';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { CreateDepartmentComponent } from '../create-department/create-department.component';
import { DepartMentService } from 'src/app/private/services/department.service';
import { CenterService } from 'src/app/private/services/center.service';
import { DeleteDepartmentComponent } from "../delete-department/delete-department.component";


@Component({
  selector: 'app-department-details',
  imports: [SharedModule, CreateDepartmentComponent, DeleteDepartmentComponent],
  templateUrl: './department-details.component.html',
  styleUrl: './department-details.component.scss'
})


export class DepartmentSectionComponent implements OnInit {
  @Input() clientId!: string;
  departments: any[] = [];
  totalRecords = 0;
  rows = 10;
  loading = true;

  displayAddModal = false;
  showEditDepartment = false;
  showDeleteDepartment = false;
  departmentDataToEdit: any = null;

  centers: any[] = [];
  addForm: FormGroup;
  departmentActionItem: MenuItem[] = [
    {
      label: 'Options',
      items: [
        {
          label: 'Edit Department',
          icon: 'pi pi-fw pi-pencil',
          command: () => {
            this.showEditDepartment = true;
          }
        },
        {
          label: 'Delete Department',
          icon: 'pi pi-fw pi-trash',
          styleClass: 'delete-menu-item',
          command: () => {
            this.showDeleteDepartment = true;
          }
        }
      ]
    }
  ];

  constructor(
    private departmentService: DepartMentService,
    private fb: FormBuilder,
    private centerService: CenterService
  ) {
    this.addForm = this.fb.group({
      dept_name: ['', Validators.required],
      client_id: ['', Validators.required],
      isPublic: [false]
    });
  }

  ngOnInit(): void {
    this.loadCenters({ first: 0, rows: this.rows });
  }

  openAddModal() {
    this.addForm.reset();
    this.displayAddModal = true;
  }

  closeAddModal() {
    this.displayAddModal = false;
    this.addForm.reset();
  }

  setDepartmentData(data: any) {
    this.departmentDataToEdit = data;
  }

  loadDepartments(event: any): void {
    this.loading = true;
    const payload = {
      page: 0,
      limit: 100,
      where: {
        client_id: this.clientId
      },
      order: {
        col: '"department"."updatedAt"',
        dir: 'DESC'
      }
    };

    this.departmentService.getDeptWithCount(payload).subscribe({
      next: (data) => {
        this.departments = data?.rows || [];
        this.totalRecords = data?.count || 0;
        this.loading = false;
      },
      error: (err) => {
        console.error('Error loading departments:', err);
        this.loading = false;
      }
    });
  }

  reload() {
    this.loadDepartments({ first: 0, rows: this.rows });
  }

  loadCenters(event: any): void {
    this.loading = true;
    const payload = {
      "page": 0,
      "limit": 100,
      "where": {
        "client_id": this.clientId,
      },
      "order": {
        "col": "\"center\".\"updatedAt\"",
        "dir": "DESC"
      }
    }

    this.centerService.getAllCenterWithCount(payload).subscribe({
      next: (data) => {
        this.centers = data?.rows || [];
        this.totalRecords = data?.count || 0;
        this.loading = false;
      },
      error: (err) => {
        console.error('Error loading centers:', err);
        this.loading = false;
      }
    });
  }
}
